import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { environment } from "src/environments/environment";
import { Zone } from "../domain/zone";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root',
})
export class ZoneTerrainService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/zoneterrain`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }


    changeZone(interventionCode: string, zoneSourceCode: string, zoneDestId: number) {
        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}/replace/${interventionCode}/${zoneSourceCode}/${zoneDestId}`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getZoneList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }
}